// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#payment-iframe-frame[data-v-1e5810b4] {
  border: none;
  width: 100%;
  height: 450px;
  overflow: auto;
}
.change-link[data-v-1e5810b4] {
  gap: 10px;
}
.change-link img[data-v-1e5810b4] {
  width: 20px;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/BookingModifyRefund.vue","webpack://./BookingModifyRefund.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;ACAF;ADEA;EACE,SAAA;ACCF;ADCE;EACE,WAAA;EACA,YAAA;ACCJ","sourcesContent":["\r\n#payment-iframe-frame {\r\n  border: none;\r\n  width: 100%;\r\n  height: 450px;\r\n  overflow: auto;\r\n}\r\n.change-link {\r\n  gap: 10px;\r\n\r\n  img {\r\n    width: 20px;\r\n    height: auto;\r\n  }\r\n}\r\n","#payment-iframe-frame {\n  border: none;\n  width: 100%;\n  height: 450px;\n  overflow: auto;\n}\n\n.change-link {\n  gap: 10px;\n}\n.change-link img {\n  width: 20px;\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
